import type { FC } from 'react';

interface Props {
  className?: string;
}

const DogParkIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6.5 8.5c1.5-1 3-1 4.5 0s3 1 4.5 0M8 12c.5-1 1.5-1 2 0s1.5 1 2 0M12 16c-2 2-6 2-8 0s-2-6 0-8 6-2 8 0 2 6 0 8z"
      />
      <circle cx="9" cy="9" r="1" fill="currentColor" />
      <circle cx="15" cy="9" r="1" fill="currentColor" />
    </svg>
  );
};

export default DogParkIcon;
